import { InfoCircleFilled } from "@ant-design/icons";
import { Layout, Typography, Row, Col, Grid } from "antd";
import React, { FC } from "react";

const { Header } = Layout;
const { Paragraph } = Typography;

interface PageHeaderProps {
  title?: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  description?: string;
}

export const PageHeader: FC<PageHeaderProps> = (props) => {
  const screens = Grid.useBreakpoint();

  return (
    <Header
      style={{
        backgroundColor: "transparent",
        marginTop: "20px",
        paddingLeft: screens.xs ? "16px" : "36px",
        paddingRight: screens.xs ? "16px" : "36px",
      }}
    >
      <Row>
        <Col span={24}>
          <div>
            <div
              style={{
                display: screens.xs ? "block" : "inline",
                whiteSpace: screens.xs ? "normal" : "nowrap",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: screens.xs ? "17px" : "28px",
                  marginRight: "6px",
                  display: screens.xs ? "block" : "inline",
                }}
              >
                {props.title}
              </span>
              <span
                style={{
                  display: screens.xs ? "block" : "inline",
                  fontSize: screens.xs ? "15px" : "28px",
                  marginTop: screens.xs ? "-36px" : "0",
                }}
              >
                {props.subTitle}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {props.description &&<InfoCircleFilled
                  style={{
                    marginRight: "8px",
                    marginTop: "4px",
                    color: "#3F4373",
                    fontSize: screens.xs ? "12px" : "inherit",
                  }}
                />}
                <div>
                    <Paragraph

                      style={{
                        margin: "0",
                        fontSize: screens.xs ? "12px" : "15px",
                        lineHeight: "1.5",
                      }}
                    >
                    {props.description}
                    </Paragraph>
                  
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Header>
  );
};
